import { Outlet, useOutletContext } from 'react-router-dom';

import { usePractice } from 'lib/hooks/queries/practice/usePractice';

const OnboardingWrapper = () => {
  const { practiceId } = useOutletContext();
  const { data } = usePractice({ practice_id: practiceId });
  if (!data?.practices) {
    return null;
  }

  const practice = {
    ...data.practices,
    roles: data.practices.roles ?? [],
    members: data.members?.members ?? [],
    total_patients: data.patients?.length ?? 0,
    active_patients: data.patients?.length ?? 0
  };

  return <Outlet context={{ practice, practiceId }} />;
};

export default OnboardingWrapper;
